<template>
  <div id="loginContainer">
    <div class="loginWindow">
      <input v-model="emailInput" v-if="!this.codeRequested" type="text" placeholder="Email" />
      <input v-model="passwordInput" v-if="!this.codeRequested" type="password" placeholder="Password" />
      <div class="mintaKode" @click="buttonHandler">{{ this.codeRequested ? 'Login' : 'Login' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = 'Login Page - Bangkok Lotteries';
  },
  methods: {
    buttonHandler() {
      if (this.buttonDisabled) {
        alert('Please wait while your request is being processed.');
      } else {
        this.buttonDisabled = true;

        fetch(`/api/requestAccessCode`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.emailInput,
            password: this.passwordInput,
          }),
        }).then(response => {
          response.json().then(res => {
            alert(res.message);
            if (response.ok) {
              localStorage.setItem('accessToken', res.accessToken);
              this.$router.push('/halaman-belakang');
            } else {
              alert('Periksa kembali email dan password.');
            }
            this.buttonDisabled = false;
          });
        });
      }
    },
  },
  data() {
    return {
      loginCode: '',
      codeRequested: false,
      buttonDisabled: false,
      emailInput: '',
      passwordInput: '',
    };
  },
};
</script>

<style>
#loginContainer {
  background: url('../assets/backgroundFirstSection.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.loginWindow {
  background-color: var(--darkColor);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 20px;
  box-sizing: border-box;
}

.mintaKode {
  background-color: var(--lightColor);
  color: var(--darkColor);
  padding: 10px 13px;
  border-radius: 5px;
  width: fit-content;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
}

#loginContainer input {
  padding: 12px 15px;
  flex-grow: 1;
  margin-right: 10px;
  border: none;
  border-radius: 5px;
  outline: none;
}
</style>
